import dayjs from 'dayjs';
import React, { useRef } from 'react'
import { Line } from 'react-chartjs-2';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
    root: {
        width: 790,
        height: 444,
        position: 'relative',
        padding: 25,
        paddingBottom: 10
    }
}));

const o = Intl.NumberFormat('en', { notation: 'compact' });


export default function Avm() {
    const classes = useStyles();
    let { data } = useParams();
    const chartRef = useRef();
    const parsedData = data.split(',').map(item => {
        const [value, date] = item.split('|');
        return { date, value: parseInt(value, 10) };
    });
    // const upwardsLineColor = '#65d5b2';
    // const downwardsLineColor = '#ff6259';
    // const firstEl = parsedData[0];
    // const lastEl = parsedData[parsedData.length - 1];
    // const lineColor = (lastEl.value - firstEl.value >= 0)
    //     ? upwardsLineColor
    //     : downwardsLineColor;
    const lineColor = '#000000';
    const renderData = {
        labels: parsedData.map(({ date }, index)=> dayjs(date).format('MMM YY')),
        datasets: [
            {
                intersect: false,
                label: 'AVM',
                fill: false,
                spanGaps: true,
                lineTension: 0.1,
                borderWidth: 2,
                backgroundColor: lineColor,
                borderColor: lineColor,
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                pointRadius: parsedData.length === 1 ? 2 : 0,
                borderJoinStyle: 'miter',
                data: parsedData.map(({ value })=> value)
            }
        ],
    };

    const plugins = [
        // {
        //     afterDraw: (chartInstance, easing) => {
        //         const ctx = chartInstance.chart.ctx;
        //         console.log('chartInstance', chartInstance.chart);
        //         // console.log('easing', easing);
        //         ctx.fillText("This text drawn by a plugin", 100, 100);
        //         // chartInstance.chart.setActiveElements([{ datasetIndex: 0, index: 0 }]);
        //     },
        // }
    ];

    return (
        <div id="templateRoot" className={classes.root}>
            <Line
                ref={chartRef}
                plugins={plugins}
                data={renderData}
                options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        enabled: true,
                        intersect: false,
                        callbacks: {
                            label: function(tooltipItem, chart){
                                var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                                return `${datasetLabel}: $${tooltipItem.yLabel.toLocaleString()}`;
                            }
                        },
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
                                display: false,
                            },
                            offset: parsedData.length === 1,
                            ticks: {
                                fontSize: 18,
                                callback: function (value, index) {
                                    return (!(index % 2)) ? value  : '';
                                },
                            },
                        }],
                        yAxes: [{
                            position: 'right',
                            gridLines: {
                                display: true,
                            },
                            ticks: {
                                fontSize: 18,
                                callback: function (value) {
                                    return `$${o.format(value)}`;
                                },
                            }
                        }]
                    },
                    legend: {
                        display: false,
                    },
                    animation: {
                        duration: 0,
                        onComplete: function () {
                            window.isLoaded = true;
                            // console.debug('chartRef', chartRef);
                            // if(chartRef.current) {
                            //     chartRef.current.setActiveElements([{ datasetIndex: 0, index: 2 }]);
                            // }
                        },
                    }
                }}
            />
        </div>
    )
}
